(() => {

  const init = (root = document) => {

    root.querySelectorAll('[data-nv-slider]').forEach(slider => {

      if (slider.dataset.ready) return;

      slider.dataset.ready = 'true';

      const track = slider.querySelector('.nv-slides');

      const dots = [...slider.querySelectorAll('[data-slide]')];

      dots.forEach((dot, index) => dot.addEventListener('click', () => track.scrollTo({left: track.clientWidth * index, behavior: 'smooth'})));

      const update = () => dots.forEach((dot, index) => dot.setAttribute('aria-current', String(index === Math.round(track.scrollLeft / track.clientWidth))));

      track.addEventListener('scroll', update, {passive: true});

      update();

    });

    root.querySelectorAll('comparison-slider').forEach(slider => {

      const range = slider.querySelector('input[type=range]');

      if (!range) return;

      range.setAttribute('aria-label', 'Comparer avant et après');

      const update = () => { slider.style.setProperty('--position', range.value + '%'); slider.querySelector('.comparison-slider__overlay').style.width = range.value + '%'; slider.querySelector('.comparison-slider__line').style.left = range.value + '%'; };

      range.addEventListener('input', update); update();

    });

    root.querySelectorAll('.main-product-atc').forEach(button => button.addEventListener('click', () => document.querySelector('.nv-product-form')?.scrollIntoView({behavior:'smooth',block:'center'})));

    root.querySelectorAll('content-tabs').forEach(tabs => tabs.querySelectorAll('.content-tab-button').forEach(button => button.addEventListener('click', () => {

      tabs.querySelectorAll('.content-tab-button').forEach(el => el.classList.toggle('content-tab-button--active', el === button));

      tabs.querySelectorAll('.content-tab').forEach(el => el.classList.toggle('content-tab--active', el.dataset.index === button.dataset.index));

    })));

    root.querySelectorAll('slideshow-component,slider-component').forEach(slider => {

      const track = slider.querySelector('.slider');

      if (!track) return;

      slider.querySelectorAll('button[name=next],button[name=previous]').forEach(button => button.addEventListener('click', () => track.scrollBy({left:(button.name === 'next' ? 1 : -1)*track.clientWidth,behavior:'smooth'})));

      slider.querySelectorAll('.slider-counter__link').forEach((button,index) => button.addEventListener('click', () => track.scrollTo({left:index*track.clientWidth,behavior:'smooth'})));

      const auto = slider.querySelector('.slideshow__autoplay');

      if (auto) auto.hidden = true;

    });

  };

  init();

  const initMenu=()=>{
    const menu=document.querySelector('.nv-menu'),trigger=document.querySelector('[data-open-menu]');
    if(!menu||!trigger||menu.dataset.bound)return;menu.dataset.bound='true';let closeTimer;
    const close=()=>{menu.classList.remove('is-open');clearTimeout(closeTimer);closeTimer=setTimeout(()=>menu.close(),250);};
    trigger.addEventListener('click',()=>{clearTimeout(closeTimer);menu.showModal();document.documentElement.classList.add('nv-menu-open');trigger.setAttribute('aria-expanded','true');requestAnimationFrame(()=>requestAnimationFrame(()=>menu.classList.add('is-open')));});
    menu.querySelector('[data-close-menu]').addEventListener('click',close);
    menu.addEventListener('cancel',e=>{e.preventDefault();close();});
    menu.addEventListener('close',()=>{menu.classList.remove('is-open');document.documentElement.classList.remove('nv-menu-open');trigger.setAttribute('aria-expanded','false');menu.querySelectorAll('details[open]').forEach(d=>d.open=false);trigger.focus();});
    menu.addEventListener('click',e=>{if(e.target===menu&&e.clientX>menu.getBoundingClientRect().right)close();const back=e.target.closest('[data-menu-back]');if(back){const details=back.closest('details');details.open=false;details.querySelector('summary').focus();}});
  };initMenu();document.addEventListener('shopify:section:load',initMenu);
  document.addEventListener('shopify:section:load', event => init(event.target));

})();